// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import DownCircleOutlinedSvg from "@fishx/icons-svg/es/asn/DownCircleOutlined";
import FishxIcon from '../components/FishxIcon';

var DownCircleOutlined = function DownCircleOutlined(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: DownCircleOutlinedSvg
  }));
};

DownCircleOutlined.displayName = 'DownCircleOutlined';
export default React.forwardRef(DownCircleOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/DownCircleOutlined.js
// module id = 2451
// module chunks = 0